import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import API from '../../../../utils/API';
import TimeField from '../../../../components/inputs/timeField';

class CreateRegistrationFlowTicketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
            description: '',
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
            price: 0,
            quantity: 0,
            submitting: false,
            invalid: false,
            success: false,
            requiredFields: {
                label: false,
                description: false,
                startDate: false,
                endDate: false,
                startTime: false,
                endTime: false,
                price: false,
                quantity: false
            }
        };
    }


    submit = () => {
        const { orgId, eventId, flowId } = this.props;
        const { label, description, startDate, endDate, startTime, endTime, price, quantity } = this.state;

        const requiredFields = {
            label: !label,
            description: !description,
            startDate: !startDate,
            endDate: !endDate,
            startTime: !startTime,
            endTime: !endTime,
            price: !price,
            quantity: !quantity
        };
        this.setState({ requiredFields });
        if (Object.values(requiredFields).some((field) => field)) {
            this.setState({ invalid: true });
            return;
        }
        this.setState({ submitting: true });

        API().post(`Organizations/${orgId}/events/${eventId}/registrationFlows/${flowId}/tickets`, {
            label,
            description,
            startDate,
            endDate,
            startTime,
            endTime,
            price,
            quantity,
        }).then((res) => {
            if (res.data) {
                this.setState({ success: true, submitting: false });
                this.props.updateFlow(res.data);
            } else {
                this.setState({ submitting: false });
            }
        });
    };

    render() {
        const { isOpen } = this.props;
        const { label, description, startDate, endDate, startTime, endTime, price, quantity, submitting, success, requiredFields } = this.state;

        return (
            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Create Registration Ticket"}
                    bodyHeaderText="Create a paid ticket to accept payments for access to your event."
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Ticket Label"
                                    classes={'w-100'}
                                    value={label}
                                    onChange={(e) => this.setState({ label: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.label}
                                    name="label"
                                    type="text"
                                    placeholder="Enter ticket label"
                                />
                                <InputField
                                    label="Ticket Description"
                                    classes={'w-100'}
                                    value={description}
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.description}
                                    name="description"
                                    type="text"
                                    placeholder="Enter ticket description"
                                />
                                <div className='flex gap10'>
                                    <InputField
                                        label="Start Date"
                                        classes={'w-100'}
                                        value={startDate}
                                        type="date"
                                        onChange={(e) => this.setState({ startDate: e.target.value })}
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        errorTrigger={requiredFields.startDate}
                                        name="startDate"
                                        placeholder="Enter start date"
                                    />
                                    <TimeField
                                        label="Start Time"
                                        classes={'w-100'}
                                        value={startTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ startTime: e })}
                                        errorTrigger={requiredFields.startTime}
                                        name="startTime"
                                        placeholder="Enter start time"/>
                                </div>
                                <div className='flex gap10'>
                                    <InputField
                                        label="End Date"
                                        classes={'w-100'}
                                        value={endDate}
                                        type="date"
                                        onChange={(e) => this.setState({ endDate: e.target.value })}
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        errorTrigger={requiredFields.endDate}
                                        name="endDate"
                                        placeholder="Enter end date"
                                        min={startDate}
                                    />
                                    <TimeField
                                        label="End Time"
                                        classes={'w-100'}
                                        value={endTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        onChange={(e) => this.setState({ endTime: e })}
                                        errorTrigger={requiredFields.endTime}
                                        name="endTime"
                                        placeholder="Enter end time"/>
                                </div>
                                <div className='flex gap10'>
                                    <InputField
                                        label="Price"
                                        classes={'w-100'}
                                        value={price}
                                        type="number"
                                        onChange={(e) => this.setState({ price: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.price}
                                        name="price"
                                        placeholder="Enter ticket price"
                                    />
                                    <InputField
                                        label="Quantity"
                                        classes={'w-100'}
                                        value={quantity}
                                        type="number"
                                        onChange={(e) => this.setState({ quantity: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.quantity}
                                        name="quantity"
                                        placeholder="Enter ticket quantity"
                                    />
                                </div>
                            </div>

                        )
                    }}
                    toggle={this.props.toggle}
                    actionButtonLabel={!success ? !submitting ? 'Submit' : 'Creating...' : ''}
                    cancelButtonLabel={success && 'Close'}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}

                ></FieldModal>
            </div>
        )

    }
}

export default CreateRegistrationFlowTicketModal;
